import './index.scss';
import Activity from '../components/activity';
import ActivitiesList from '../components/activities_list';
import QueryString from 'utils/query_string';

export default class Timeline {
  start() {
    this.activitySelectorClass = '.js-activity';

    this.$component = $('.js-timeline');
    this.$timelineFeed = $('.js-timeline-feed', this.$component);

    if (!this.$timelineFeed.length) return;

    this.$timelineLoader = $('.js-timeline-loader', this.$component);

    if (this.$component.length) {
      vendorManager.ensure('autosize', () => {
        vendorManager.ensure('moment', () => {
          EventManager.subscribe('timeline', (msg, data) => this.delegator(msg, data));

          // Bootstrapping Timeline
          this.renderNewActivityPage(1);
        });
      });
    }
  }

  renderNewActivityPage(page = null) {
    const $lastPage = $('[data-next-page]', this.$timelineFeed).last();
    const userId = parseInt(this.$timelineFeed.data('user-id'));
    page = page || $lastPage.data('next-page');
    const data = QueryString.getQueryStringData();
    
    ActivitiesList.getList(page, userId, data.source)
      .then(html => {
        this.$timelineFeed.append($(html).addClass('appended'));
        const $page = $(`[data-page="${page}"]`, this.$timelineFeed);
        const totalPages = $page.data('total-pages');

        $(this.activitySelectorClass, $page)
          .each((i, activity) => {
            new Activity(activity);
          });

        EventManager.publish('timeline.page.loaded', {last: !totalPages || page === totalPages});
      })
      .catch(err => console.log(err));
  }

  renderNewActivity(html) {
    this.$timelineFeed.prepend($(html).addClass('appended'));
    (new Activity(this.$timelineFeed.find(this.activitySelectorClass).get(0)));
    $('.js-empty-timeline', this.$component).remove();
  }

  delegator(msg, data) {
    switch (msg) {
      case 'timeline.activity.new':
        this.renderNewActivity(data);
        break;
      case 'timeline.page.load':
        this.renderNewActivityPage(data);
        break;
    }
  }
}
